import { store } from 'redux/store';
import { useCallback, useEffect, useState } from 'react';

import { Partner } from 'types';

import { getOperationParticipants } from 'modules/transactions/api/getOperationParticipants';

type UseGetOperationPartnersProps = {
  operationId: string | undefined;
  page: number;
  rowsPerPage?: number;
};

const fields = 'id name dividends contributions splits';

export const useGetOperationPartners = ({
  operationId,
  page,
  rowsPerPage = 10,
}: UseGetOperationPartnersProps) => {
  const [partners, setPartners] = useState<Partner[]>([]);
  const [totalPartners, setTotalPartners] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getParticipants = useCallback(async () => {
    if (!operationId) return;

    setIsLoading(true);

    try {
      const data = await store.dispatch(
        getOperationParticipants({
          operationId,
          params: {
            fields,
            page,
            items: rowsPerPage,
          },
        })
      );

      const { partners, total } = data;

      setPartners(partners);
      setTotalPartners(total);

      setIsLoading(false);
    } catch {
      setIsLoading(false);
    }
  }, [operationId, page, rowsPerPage]);

  useEffect(() => {
    getParticipants();
  }, [getParticipants]);

  return { data: { partners, totalPartners }, isLoading };
};
